"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var JapanOverview1 = function JapanOverview1(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    width: "44",
    height: "22",
    viewBox: "0 0 44 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.432 3.536L14.32 5.12C16.768 7.976 18.136 11.984 18.424 17.144L21.088 17.024C20.8 11.312 19.24 6.8 16.432 3.536ZM0.592 3.536C0.232 5.888 0.0640001 8.12 0.0640001 10.28C0.0640001 13.472 0.568 15.992 1.6 17.816C2.632 19.64 4.072 20.552 5.92 20.552C7.072 20.552 8.032 20.024 8.8 18.992C9.52 17.984 10.144 16.4 10.648 14.24L8.032 13.592C7.84 14.6 7.624 15.44 7.384 16.112C6.952 17.312 6.424 17.936 5.848 17.936C5.08 17.936 4.408 17.336 3.832 16.184C3.112 14.768 2.752 12.8 2.752 10.28C2.752 8.096 2.92 5.96 3.256 3.872L0.592 3.536ZM43.6 3.944C40.48 4.136 36.832 4.28 32.68 4.376C32.872 3.272 33.016 2.072 33.136 0.8L30.568 0.655999C30.448 1.952 30.28 3.2 30.064 4.424C28.24 4.424 26.32 4.448 24.304 4.448V6.872C26.056 6.872 27.784 6.848 29.512 6.848C29.464 6.992 29.416 7.136 29.392 7.28C28.648 9.896 27.664 11.96 26.464 13.448L28.264 15.008C29.608 14 31.048 13.232 32.608 12.656C34.144 12.08 35.584 11.816 36.928 11.816C38.104 11.816 39.04 12.08 39.712 12.656C40.36 13.208 40.696 13.952 40.696 14.864C40.696 15.92 40.264 16.784 39.424 17.408C38.368 18.2 36.712 18.608 34.504 18.608C32.728 18.608 31 18.464 29.32 18.176L29.08 20.576C30.712 20.864 32.512 21.032 34.504 21.032C37.552 21.032 39.832 20.408 41.344 19.208C42.64 18.128 43.312 16.688 43.312 14.864C43.312 13.184 42.688 11.84 41.464 10.856C40.288 9.896 38.776 9.44 36.928 9.44C34.936 9.44 32.8 10.04 30.544 11.24C31.192 10.112 31.744 8.624 32.2 6.8C36.136 6.704 39.976 6.584 43.72 6.392L43.6 3.944Z",
    fill: fill
  }));
};
JapanOverview1.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
JapanOverview1.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = JapanOverview1;